import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { TEAM_CONFIGURATION_PAGE } from "@common/page-route-providers";
import { IAdaptRoute } from "@common/route/page-route-builder";
import { AuthorisationService } from "@org-common/lib/authorisation/authorisation.service";
import { EMPTY, Observable, switchMap } from "rxjs";
import { ConfigArea } from "../../configuration/configuration-types";
import { CommonTeamsAuthService } from "../common-teams-auth.service";

@Component({
    selector: "adapt-team-people-dashboard-element",
    templateUrl: "./team-people-dashboard-element.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class TeamPeopleDashboardElementComponent implements OnInit {
    @Input() public team!: Team;

    public url$?: Observable<string>;

    public constructor(
        private authService: AuthorisationService,
        @Inject(TEAM_CONFIGURATION_PAGE) private teamConfigurationPageRoute: IAdaptRoute<{ teamId: number }>,
    ) { }

    public ngOnInit() {
        this.url$ = this.authService.getHasAccess(CommonTeamsAuthService.ConfigureTeam, this.team).pipe(
            switchMap((canConfigureTeam) => canConfigureTeam
                ? this.teamConfigurationPageRoute.getRoute({ teamId: this.team.teamId }, { section: ConfigArea[ConfigArea.People] })
                : EMPTY),
        );
    }
}
